import axios from 'axios';

export const freeApi = axios.create({
  baseURL: 'https://free.bedrijfsdata.nl/v1.1'
});

freeApi.interceptors.request.use((config) => {

    // const token = 'olivier_345@$';
    const defaultParams = {
        limit: 10,
        front: 1,
        // token_fixed: token,
        // db: 'reg'
    };

    config.params = { 
        ...defaultParams,
        ...config.params
    };

    return config;
});

export const fetchSuggestions = async (params = {}) => freeApi.get('/suggest', { params });
